import { BuildNextOptions } from "@tanstack/react-location";

import { TLocationGenerics, paths } from "../pages/routes";
import { ExchangeMode } from "../stores";

export const getChildRoutePath = (
  route: { root: string; children: { [key: string]: string } },
  key: string
) => {
  return `${route.root}${route.children[key]}`;
};

export const exchangeTabValueToModeMap: {
  [value: string]: ExchangeMode;
} = {
  0: ExchangeMode.buy,
  1: ExchangeMode.sell,
  2: ExchangeMode.swap,
};

export const exchangeModeToTabValueMap: { [key: string]: string } = {
  [ExchangeMode.buy]: "0",
  [ExchangeMode.sell]: "1",
  [ExchangeMode.swap]: "2",
};

/**
 * This is a collection of useful and reusable routing recipes.
 */
export const locationFactories = {
  exchange: {
    buy: ({
      given: activeAssetA,
      taken: activeAssetB,
      order,
    }: TLocationGenerics["Search"]): BuildNextOptions<TLocationGenerics> => ({
      to: paths.exchange,
      search: (old) => ({
        ...old,
        mode: ExchangeMode.buy,
        ...(activeAssetA && { given: activeAssetA }),
        ...(activeAssetB && { taken: activeAssetB }),
        ...(order && { order }),
      }),
    }),
    sell: ({
      given: activeAssetA,
      taken: activeAssetB,
      order,
    }: TLocationGenerics["Search"]): BuildNextOptions<TLocationGenerics> => ({
      to: paths.exchange,
      search: (old) => ({
        ...old,
        mode: ExchangeMode.sell,
        ...(activeAssetA && { given: activeAssetA }),
        ...(activeAssetB && { taken: activeAssetB }),
        ...(order && { order }),
      }),
    }),
    swap: ({
      given: activeAssetA,
      taken: activeAssetB,
    }: TLocationGenerics["Search"]): BuildNextOptions<TLocationGenerics> => ({
      to: paths.exchange,
      search: (old) => ({
        ...old,
        mode: ExchangeMode.swap,
        ...(activeAssetA && { given: activeAssetA }),
        ...(activeAssetB && { taken: activeAssetB }),
      }),
    }),
    flipInputOutput: ({
      given: activeAssetA,
      taken: activeAssetB,
    }: TLocationGenerics["Search"]): BuildNextOptions<TLocationGenerics> => ({
      to: paths.exchange,
      search: (old) => ({
        ...old,
        mode: ExchangeMode.swap,
        given: activeAssetA,
        taken: activeAssetB,
      }),
    }),
  },
  liquidity: {
    zap: ({ zapAssetId }: TLocationGenerics["Search"]): BuildNextOptions<TLocationGenerics> => ({
      to: `${paths.liquidity.root}/${paths.liquidity.children.zap}`,
      search: (old) => ({
        ...old,
        given: zapAssetId,
      }),
    }),
  },
};
